import { GET_STUDENT_FEESTRANSACTION } from "../actions/types";

const initialState = [];

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_STUDENT_FEESTRANSACTION:
      return action.payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/getStudentFeesDetailByFeesTransactionMstId.js